import { Seo } from "@/components/common/Seo";
import { PageHero } from "@/components/common/Kinetic";
import { CtaLink } from "@/components/common/Buttons";
import { Solutions } from "@/components/home/Solutions";
import { Work } from "@/components/home/Work";
import { FinalCta } from "@/components/home/FinalCta";

export default function SolutionsPage() {
  return (
    <>
      <Seo path="/solutions" title="Business Software Solutions by Need | Quantivo"
        description="Launch a SaaS product, replace spreadsheets, connect third-party APIs, automate operations, build customer portals or modernise legacy apps with Quantivo." />
      <PageHero testId="solutions-hero" eyebrow="Solutions" lines={["Start from the problem,", "not the technology."]}
        text="We look at what slows your business down today, then design the smallest reliable system that fixes it and can grow with you.">
        <div className="mt-10"><CtaLink to="/contact" data-testid="solutions-hero-cta">Discuss Your Project</CtaLink></div>
      </PageHero>
      <Solutions index="01" />
      <Work index="02" />
      <FinalCta />
    </>
  );
}
